import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { formatPrice, convertDate } from '../../../utils';
import { openModalDetail, openModalPlanRules } from '../../../actions/purchaseActions';

import Tags, { getTag } from './../../common/Tags';

class BoxPlan extends Component {
  render() {
    if (!this.props.plan[0]) return <div />;
    const plan = this.props.plan[0];

    if (!this.props.providers[0].slug) return <div />;

    const providers = this.props.providers;

    const providerSlug = providers.filter((provider) => provider.code === plan.provider_code)[0].slug;

    const providerImgPath = `/assets/images/seguradoras/${providerSlug}.png`;

    const destinationObject = this.props.destinations.find(
      (destination) => destination.slug === this.props.match.params.destination
    );

    const destination = destinationObject ? destinationObject.name : '';
    
    const isUpsell = this.props.upsellUpgrade === String(plan.code)
    
    return (
      <div className="box box-plan">
        <div className="description-header">
          <div className="destination">{destination}</div>
          <div className="time">
            {convertDate(this.props.match.params.begin_date)} - {convertDate(this.props.match.params.end_date)}
          </div>
        </div>
        <div className="description-body">
          <div className="column-img">
            <img src={providerImgPath} alt="" />
          </div>
          <div className="column-description">
            <Tags tag={getTag(plan)} isMobile={false} customClassName="plan-tag" />

            <div className="name-plan">{plan.name}</div>
            <div className="prices-high">
              Faixa etária: {plan.child.min_age} a {plan.elder.max_age} anos <br />
              {plan.elder.min_age < plan.elder.max_age && (
                <React.Fragment>
                  R$ {formatPrice(plan.elder.price)}
                  &nbsp;maiores de {plan.adult.max_age} anos
                </React.Fragment>
              )}
            </div>

            <div className="box-plans-row">
              {plan.benefits &&
                plan.benefits.map(
                  (benefit, i) =>
                    benefit.code === 42 && (
                      <div key={i}>
                        <strong>{benefit.coverage}</strong> <br />
                        <span>Despesa médica hospitalar</span>
                      </div>
                    )
                )}

              {plan.benefits &&
                plan.benefits.map(
                  (benefit, i) =>
                    benefit.code === 51 && (
                      <div key={i}>
                        <strong>{benefit.coverage}</strong> <br />
                        <span>Despesa médica hospitalar</span>
                      </div>
                    )
                )}
            </div>

            <div className="box-plans-row roof desktop">
              <button onClick={this.props.openModalDetail} className="ver-mais">
                Cobertura completa
              </button>
              <button onClick={this.props.openModalPlanRules} className="plan-rules">
                Informações e Regras do Plano
              </button>
            </div>
          </div>
        </div>

        <div className="box-plans-row roof mobile">
          <button onClick={this.props.openModalDetail} className="ver-mais">
            Cobertura completa
          </button>
          <button onClick={this.props.openModalPlanRules} className="plan-rules">
            Informações e Regras do Plano
          </button>
        </div>
      </div>
    );
  }
}

export default withRouter(
  connect(
    (state) => ({
      plan: state.search.plans,
      destinations: state.global.destinations,
      providers: state.global.providers,
      upsellUpgrade: state.purchase.upsellUpgrade,
    }),
    {
      openModalDetail,
      openModalPlanRules,
    }
  )(BoxPlan)
);



// WEBPACK FOOTER //
// ./src/components/purchase/purchase_description/BoxPlan.jsx